<template>
  <div class="bg-customBg card tw-items-dashed-group tw-document-sender">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div class="card-title mb-0">{{ $t("task.printDocument.sentCTA") }}</div>
      <span class="cursor-pointer" @click="onClose"
      ><svg
          width="30"
          height="30"
          viewBox="0 0 30 30"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
      >
          <rect
              opacity="0.5"
              x="6"
              y="17.3137"
              width="16"
              height="2"
              rx="1"
              transform="rotate(-45 6 17.3137)"
              fill="currentColor"
          ></rect>
          <rect
              x="7.41422"
              y="6"
              width="16"
              height="2"
              rx="1"
              transform="rotate(45 7.41422 6)"
              fill="currentColor"
          ></rect>
        </svg>
      </span>
    </div>

    <div class="card-body pt-2 pb-2">
      <div class="row form-group mb-0">
        <div class="col-lg-12 col-md-12 col-sm-12 form-control no-border">
          <label class="d-block mb-0 small text-muted">
            {{ $t("task.printDocument.templateForwardDocuments.recipient") }}
          </label>
          <searchable-select
              dense
              outlined
              multiple
              v-model="emailSendList"
              :options="senderEmails?.items"
          />
        </div>
      </div>

      <div class="row">
        <div v-for="(template, index) in templateSelected" :key="index">
          <q-btn
              class="btn btn-action btn-sm font-size-12"
              icon="close"
              :label="template.fileName"
              @click="removeFile(template)"
          />
        </div>
      </div>
      <div class="row form-group mb-0">
        <div class="col-lg-12 col-md-12 col-sm-12 form-control no-border">
          <div class="col-12">
            <q-input
                type="textarea"
                bg-color="white"
                dense
                outlined
                disable
                :model-value="body"
                class="w-100"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="card-footer d-flex justify-content-end">
      <q-btn
          class="btn btn-primary"
          :label="$t('task.printDocument.sentCTA')"
          icon="send"
          @click="sendMail"
          :loading="isLoadingSend"
          :disable="emailSendList.length === 0"
      >
        <template v-slot:loading>
          <q-spinner-facebook />
        </template>
      </q-btn>
    </div>
  </div>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";

import store from "@/store";
import {NoticeTemplate} from "@/types";

@Options({
  watch: {
    templateSelected(newValue) {
      if (!newValue || !newValue.length) {
        this.onClose();
      }
    },
  },
})
export default class PrintDocumentSender extends Vue {
  emailSendList: string[] = [];

  get templateSelected() {
    return store.state.printDocumentModule.templates.filter((t) => t.selected);
  }

  created() {
    store.dispatch("printDocumentModule/getNoticeTemplateBody");

    switch (this.currentRoute) {
      case "order-edit": {
        store.dispatch('printDocumentModule/getEmailSendListOption', {
          entity: store.state.orderModule.order,
          entityType: 'order'
        })
        break
      }
      case "TaskDetail": {
        const entityType = store.getters['taskModule/isTaskModuleOffer'] ? 'offer' : 'order'
        if (entityType === 'offer') {
          store.dispatch('printDocumentModule/getEmailSendListOption', {
            entity: store.state.taskModule.offer,
            entityType: entityType
          })
        } else {
          store.dispatch('printDocumentModule/getEmailSendListOption', {
            entity: store.state.taskModule.order,
            entityType: entityType
          })
        }
        break
      }
      case "demand-edit": {
        store.dispatch('printDocumentModule/getEmailSendListOption', {
          entity: store.state.demandModule.offer,
          entityType: 'offer'
        })
        break
      }
      case "third-edit": {
        store.dispatch('printDocumentModule/getEmailSendListOption', {
          entity: store.state.thirdModule.third,
          entityType: 'party'
        })
        break
      }
    }
  }

  get body() {
    return store.state.printDocumentModule.body;
  }


  get senderEmails() {
    return store.getters['printDocumentModule/getEmailSendListOption'];
  }

  onClose() {
    store.dispatch("printDocumentModule/changeShowSendTemplate", false);
  }

  removeFile(tempalte: NoticeTemplate) {
    store.dispatch("printDocumentModule/setTemplateSelected", {
      template: tempalte,
      selected: false,
    });
  }
  isLoadingSend = false;
  filesIds:any = [];

  sendMail() {
    this.isLoadingSend = true;
    for(let i = 0; i < this.templateSelected.length; i++){
      store.dispatch("printDocumentModule/generateDocument", {
        templatesSelected: [this.templateSelected[i]],
        currentRoute: this.currentRoute,
        callback: this.onSendDocument,
      });
    }
  }

  async onSendDocument(){
    this.filesIds.push(this.fileId)
    const emailSendList: string[] = [];
    this.emailSendList.forEach((element: any) => {
      emailSendList.push(element.value);
    });
    if(this.templateSelected.length === this.filesIds.length){
      store.dispatch("printDocumentModule/sendDocument", {
        templateSelected : this.templateSelected,
        emailSendList: emailSendList,
        fileId: this.filesIds,
        callback: this.sendResponse,
      });
    }
  }

  sendResponse() {
    this.isLoadingSend = false;
  }

  get fileId() {
    return store.state.printDocumentModule.fileDetailFileId
  }
  get currentRoute() {
    return this.$router.currentRoute.value.name;
  }
}
</script>
  <style scoped>
   .bg-customBg {
      background-color: #E7F3FF !important;
    }
  </style>

